import React, { useState, useEffect, useRef } from 'react';
import { Toast } from '../../generated/gql';
import { useToasts } from '../../graphql/toasts/useToasts';
import { CrossIcon } from 'ui-components/src/components/atoms/icons';

import { Bar, Content, Message, StyledIconButton } from './styles';

export const ToastBar = () => {
  const { toasts, popToast } = useToasts();
  const [activeToast, setActiveToast] = useState<Toast | null>(null);
  const toastTimeout = useRef<number>(0);

  useEffect(() => {
    if (toasts?.length && !toastTimeout.current) {
      const interval = window.setTimeout(() => {
        toastTimeout.current = 0;
        popToast();
      }, 5000);

      setActiveToast(toasts[0]);
      toastTimeout.current = interval;
    } else if (!toasts?.length) {
      clearInterval(toastTimeout.current);
      toastTimeout.current = 0;
    }

    return () => {
      clearInterval(toastTimeout.current);
    };
  }, [toasts, popToast]);

  return (
    <Bar $active={!!toasts?.length}>
      <Content>
        <Message>{activeToast ? activeToast.message : null}</Message>
        <StyledIconButton
          icon={<CrossIcon />}
          onClick={() => {
            toastTimeout.current = 0;
            popToast();
          }}
        />
      </Content>
    </Bar>
  );
};
